<template lang="pug">
div
  v-dialog(:value="!!showDetails" @input="showDetails = null" max-width="900")
    v-card(v-if="showDetails")
      v-card-title.grey.lighten-4
        .title {{showDetails.title}}
        v-spacer
        v-btn(icon @click="showDetails = null"): v-icon close
      template(v-for="video in videos")
        video-player.wrap-aspect.ratio-16-9(ref="player" :options="videoOptions(video)")
      v-card-text
        div(v-html="showDetails.content")
        ul.mt-4(v-if="downloads.length")
          li.iconable(v-for="med in downloads" :key="med.id")
            a(:href="med.url" target="_blank")
              v-icon.icon(small) cloud_download
              |  {{med.title}}
  ul
    li.openable(v-for="cat in categories" :key="cat.id" v-if="cat.children.length || cat.contents.length")
      a(@click="toggleOpen(cat)")
        v-icon.icon(:class="{closed: !cat.open}" small) arrow_drop_down
        |  {{cat.name}}
      div(v-if="cat.open")
        extra-mein-schreibtisch-prozesse(:categories="cat.children" :contents="cat.contents")
    template(v-for="con in contents")
      template(v-if="(con.content||'').length > 10")
        li.iconable
          a(@click="show(con)")
            v-icon.icon(small) description
            |  {{con.title}}
      template(v-else)
        li.iconable(v-if="con.links.length === 0 && con.media.length === 1 && con.media[0].title === con.title")
          a(:href="con.media[0].url" target="_blank")
            v-icon.icon(small) cloud_download
            |  {{con.media[0].title}}
        li.iconable(v-else-if="con.links.length === 1 && con.media.length === 0 && con.links[0].name === con.title")
          a(:href="con.links[0].url" target="_blank")
            v-icon.icon(small) open_in_new
            |  {{con.links[0].name}}
        li.openable(v-else)
          a(@click="toggleOpen(con)")
            v-icon.icon(:class="{closed: !con.open}" small) arrow_drop_down
            |  {{con.title}}
          ul
            template(v-if="con.open")
              li.iconable(v-for="med in con.media" :key="med.id")
                a(:href="med.url" target="_blank")
                  v-icon.icon(small) cloud_download
                  |  {{med.title}}
              li.iconable(v-for="link in con.links" :key="`link-${link.id}`")
                a(:href="link.url" target="_blank")
                  v-icon.icon(small) open_in_new
                  |  {{link.name}}

</template>

<style lang="stylus" scoped>
a
  text-decoration none

.openable, .iconable
  list-style-type none
  .icon
    margin-left -24px
    width 24px

.closed
	transform rotate(-90deg)

</style>

<script>
import ExtraMeinSchreibtischProzesse from './extra-mein-schreibtisch-prozesse'
import { sortBy } from 'lodash'

export default {
  name: 'extra-mein-schreibtisch-prozesse',
  props: ['categories', 'contents'],
  components: {
    ExtraMeinSchreibtischProzesse
  },
  data() {
    return {
      showDetails: null
    }
  },
  computed: {
    media() {
      return sortBy(this.showDetails && this.showDetails.media || [], 'title')
    },
    downloads() {
      return this.media.filter(m => !m.video)
    },
    videos() {
      return this.media.filter(m => m.video)
    }
  },
  methods: {
    toggleOpen(item) {
      item.open = !item.open
    },
    show(content) {
      this.showDetails = content
    },
    videoOptions(video) {
      const src = video.video.replace(/youtube:/, 'https://www.youtube.com/v/')
      return {
        poster: video.url,
        sources: [ { src: src, type: 'video/youtube' } ],
        techOrder: ["html5", "Youtube"],
        thumb: video.url,
        title: video.title,
        v: video,
      }
    }
  }
}
</script>
